import React from 'react';
import {Avatar} from '@mui/material';
import {storage} from '../core/firebase';
import {getDownloadURL, ref} from 'firebase/storage';
import {PersonPinCircleRounded} from "@mui/icons-material";

const CheckInPhoto = ({ src, sx, alt, variant = 'circular' }) => {
    const [url, setUrl] = React.useState(null);

    React.useEffect(() => {
        let isActive = true;
        if (!src) {
            setUrl(null);
            return () => {
                isActive = false;
            };
        }
        if (typeof src === 'string' && (src.startsWith('http://') || src.startsWith('https://'))) {
            setUrl(src);
            return () => {
                isActive = false;
            };
        }
        setUrl(null);
        getDownloadURL(ref(storage, src))
            .then((nextUrl) => {
                if (isActive) {
                    setUrl(nextUrl);
                }
            })
            .catch(() => {
                if (isActive) {
                    setUrl(null);
                }
            });
        return () => {
            isActive = false;
        };
    }, [src]);

    return url ? (
        <Avatar src={url} alt={alt || 'Check-in Photo'} sx={sx} variant={variant} />
    ) : (
        <PersonPinCircleRounded sx={{ fontSize: 40}}/>
    );
};

export default CheckInPhoto;
